angular.module("Main").controller("PayPalShopCancelController", ["$rootScope", "$scope", "$state", "$window", "$stateParams", "$location", "$translate", "ShopService", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $window, $stateParams, $location, $translate, ShopService, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'shopData');
            //unregisterEventHandler();
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});

        });
        BookingService.getCurrency().then(function (data) {
            vm.currency = data;
            if (vm.currency.Waehrung === "EUR")
                vm.currency.Waehrung = "€";
        });

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        getKursbuchungLayouKonfiguration();


        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        if (!SessionService.getSessionId()) {
            $state.go("shop", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else {
            ShopService.checkStatus($stateParams.oid).then(function (data) {
                vm.shopData = ({
                    Name: data.Bezeichnung,
                    Preis: data.Preis,

                });
                vm.hasError = false;
                if (!_.isNil($stateParams.oid))
                    ShopService.cancelBooking($stateParams.oid, $translate.use(), 'CANCELED');
            })
        }


    }])